import React, { useEffect, lazy, Suspense } from 'react';
import './commonstyles/colors.css';
import './commonstyles/typography.css';
import './commonstyles/utils.css';
import './commonstyles/button.css';
import './commonstyles/inputfield.css';
import './commonstyles/alert.css';
import './commonstyles/header.css';
import './commonstyles/tab.css';
import './assets/scss/datatable.scss';
import { BrowserRouter as Router} from 'react-router-dom';
import { createStore, combineReducers } from 'redux';
import user_info_reducer from './redux/reducer';
import logout_reducer from './redux/Logout/logout_reducer/logout_reducer';
import access_reducer from './redux/access/access_reducer/access_reducer';
import { Provider } from 'react-redux';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import companyinfo_reducer from './redux/companyinfo/reducer';
import Loader from './admin/components/loader/Loader';
import ScrollToTop from './shared/ScrollTop';

const PublicRoutes = lazy(() => import('./PublicRoutes'));

const reducers = {
  user_info_reducer,
  logout_reducer,
  access_reducer,
  companyinfo_reducer,
}
const reducer = combineReducers(reducers);
const store = createStore(reducer);
const theme = createTheme({
  typography: {
    allVariants: {
      fontFamily: 'Roboto',
      textTransform: 'none',
      fontSize: 16,
    },
  },
})
function App() {
  
  useEffect(()=> {
    let logoURL = process.env.REACT_APP_RESOURCES_URL;
    let appTitle = process.env.REACT_APP_MAIN_TITLE;
    let appIcon = process.env.REACT_APP_ICON;
    document.getElementById("mainTitle").innerHTML = appTitle;
    document.getElementById("mainLogo").href = logoURL+"appasset/images/" + appIcon;
    const script = document.getElementById("gsiScript");
    if (script && !script.src) {
      script.src = `${process.env.REACT_APP_GOOGLE_PLATFORM_SCRIPT}?onload=intiGSSo`;
      script.async = true;
      script.defer = true;
      script.onload = () => {
        console.log("Google platform script loaded");
      };
    }
  },[])

  function loadStart(){    
    if(window.location.href.indexOf("safestart-survey") > -1 && window.location.href.indexOf('#') > -1 && !localStorage.getItem('sc_user')){        
        localStorage.setItem('sc_user', 'true');            
    }
  }

  loadStart();
  
  return (
    <Router>
    <ThemeProvider theme={theme}>
      <Provider store={store}>
          <Suspense fallback={<Loader/>}>
            <ScrollToTop />
            <PublicRoutes />
          </Suspense>
      </Provider>
    </ThemeProvider>
    </Router>
  );
}

export default App;
